/**
 * Website settings service.
 *
 * Backed by the settings/website singleton: company/contact details, social
 * links, and the header/body code-injection payloads. Managed from
 * /admin/settings and /admin/code-injection.
 */
import { mockWebsiteSettings } from "@/data/mock-settings";
import { USE_MOCK_DATA } from "@/lib/firebase";
import { getByIdCached } from "@/lib/firestore-data";

const delay = (ms = 30) => new Promise((res) => setTimeout(res, ms));

export const SETTINGS_DOC_ID = "website";

export async function getWebsiteSettings() {
    if (USE_MOCK_DATA) {
        await delay();
        return mockWebsiteSettings;
    }

    try {
        const settings = await getByIdCached("settings", SETTINGS_DOC_ID);
        // Merge over the bundled defaults so a partially-filled doc still yields
        // every field the footer and contact page read.
        return settings ? { ...mockWebsiteSettings, ...settings } : mockWebsiteSettings;
    } catch (err) {
        console.warn("[settings] falling back to bundled settings:", err.message);
        return mockWebsiteSettings;
    }
}
